import { createBrowserRouter } from 'react-router-dom'
import ProtectedRoute from '../components/auth/ProtectedRoute'
import PublicRoute from '../components/auth/PublicRoute'
import AircraftDetailPage from '../pages/aircraft/AircraftDetailPage'
import AircraftPage from '../pages/aircraft/AircraftPage'
import AirlineDetailPage from '../pages/airlines/AirlineDetailPage'
import AirlineFormPage from '../pages/airlines/AirlineFormPage'
import AirlinesPage from '../pages/airlines/AirlinesPage'
import AirportDetailPage from '../pages/airports/AirportDetailPage'
import AirportFormPage from '../pages/airports/AirportFormPage'
import AirportPage from '../pages/airports/AirportPage'
import AuthPage from '../pages/auth/AuthPage'
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage'
import BaggageDetailsPage from '../pages/bagages/BaggageDetailsPage'
import BaggagePage from '../pages/bagages/BaggagePage'
import BookingDetailsPage from '../pages/bookings/BookingDetailsPage'
import BookingPage from '../pages/bookings/BookingPage'
import DashboardPage from '../pages/dashboard/DashboardPage'
import NotFoundPage from '../pages/error/NotFoundPage'
import FlightAttendantDetailPage from '../pages/flight-attendants/FlightAttendantDetailPage'
import FlightAttendantPage from '../pages/flight-attendants/FlightAttendantPage'
import FlightDetailPage from '../pages/flights/FlightDetailPage'
import FlightsPage from '../pages/flights/FlightsPage'
import HomePage from '../pages/home/HomePage'
import PassengerDetailPage from '../pages/passengers/PassengerDetailPage'
import PassengersPage from '../pages/passengers/PassengersPage'
import PilotDetailPage from '../pages/pilots/PilotDetailPage'
import PilotsPage from '../pages/pilots/PilotsPage'
import PlaceholderPage from '../pages/placeholder/PlaceholderPage'
import SettingsPage from '../pages/settings/SettingsPage'
import SimulationDetailPage from '../pages/simulations/SimulationDetailPage'
import SimulationHistoryPage from '../pages/simulations/SimulationHistoryPage'
import SimulationsPage from '../pages/simulations/SimulationsPage'

const router = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        path: 'login',
        element: (
          <PublicRoute>
            <AuthPage />
          </PublicRoute>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        ),
      },
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <HomePage title="DialVerse" />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: 'simulations',
            element: <SimulationsPage />,
          },
          {
            path: 'simulations/:simulationNumber',
            element: <SimulationDetailPage />,
          },
          {
            path: 'simulations/:simulationNumber/history',
            element: <SimulationHistoryPage />,
          },
          {
            path: 'flights',
            element: <FlightsPage />,
          },
          {
            path: 'flights/:flightId',
            element: <FlightDetailPage />,
          },
          {
            path: 'pilots',
            element: <PilotsPage />,
          },
          {
            path: 'pilots/:pilotId',
            element: <PilotDetailPage />,
          },
          {
            path: 'airlines',
            element: <AirlinesPage />,
          },
          {
            path: 'airlines/new',
            element: <AirlineFormPage />,
          },
          {
            path: 'airlines/:airlineId',
            element: <AirlineDetailPage />,
          },
          {
            path: 'airlines/:airlineId/edit',
            element: <AirlineFormPage />,
          },
          {
            path: 'airports',
            element: <AirportPage />,
          },
          {
            path: 'airports/new',
            element: <AirportFormPage />,
          },
          {
            path: 'airports/:airportId',
            element: <AirportDetailPage />,
          },
          {
            path: 'airports/:airportId/edit',
            element: <AirportFormPage />,
          },
          {
            path: 'aircraft',
            element: <AircraftPage />,
          },
          {
            path: 'aircraft/:aircraftId',
            element: <AircraftDetailPage />,
          },
          {
            path: 'baggages',
            element: <BaggagePage />,
          },
          {
            path: 'baggages/:baggageId',
            element: <BaggageDetailsPage />,
          },
          {
            path: 'bookings',
            element: <BookingPage />,
          },
          {
            path: 'bookings/:bookingId',
            element: <BookingDetailsPage />,
          },
          {
            path: 'passengers',
            element: <PassengersPage />,
          },
          {
            path: 'passengers/:passengerId',
            element: <PassengerDetailPage />,
          },
          {
            path: 'flight-attendants',
            element: <FlightAttendantPage />,
          },
          {
            path: 'flight-attendants/:flightAttendantId',
            element: <FlightAttendantDetailPage />,
          },
          {
            path: 'analytics',
            element: (
              <PlaceholderPage
                title="Analytics"
                description="View detailed analytics and reports"
              />
            ),
          },
          {
            path: 'settings',
            element: <SettingsPage />,
          },
          {
            path: 'account',
            element: (
              <PlaceholderPage title="Account" description="Manage your account and profile" />
            ),
          },
          {
            path: 'account/settings',
            element: (
              <PlaceholderPage
                title="Account Settings"
                description="Manage your account and profile"
              />
            ),
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])

export default router
